import { styled } from '@mui/material/styles'
import { CardStandart } from 'ui/CardStandart'
import { GAP_SIZE } from '../constants'

export const GridContainer = styled('div')<{ customCellSize?: number }>`
	display: grid;
	gap: ${GAP_SIZE}px;
	width: fit-content;
	max-width: 100%;
	box-sizing: border-box;
	overflow: visible;

	/* Фиксированные размеры колонок без растягивания */
	grid-template-columns: repeat(
		auto-fit,
		${props => props.customCellSize || 168}px
	);
	grid-auto-rows: ${props => props.customCellSize || 168}px;
`

export const WidgetContainer = styled(CardStandart)<{
	w: number
	h: number
	isDragging?: boolean
	customCellSize?: number
	y?: number
}>`
	padding: ${props => (props.customCellSize ? '16px' : '24px')};
	gap: 16px;
	position: relative;
	grid-column: ${props => (props.w === -1 ? '1 / -1' : `span ${props.w}`)};
	grid-row: span ${props => props.h};

	transition:
		opacity 0.2s ease,
		box-shadow 0.2s ease;

	display: flex;
	flex-direction: column;
	overflow: visible;

	/* Стили для перетаскивания */
	${props =>
		props.isDragging &&
		`
		opacity: 0.5;
		z-index: 1000;
	`}

	/* Стили для FULL виджетов */
	${props =>
		props.w === -1 &&
		`
		box-sizing: border-box;
		width: 100% !important;
		max-width: 100% !important;
	`}

	/* Адаптивные стили для разных размеров ячеек */
	${props =>
		props.customCellSize &&
		props.customCellSize > 200 &&
		`
		padding: 20px;
		gap: 20px;
	`}

	${props =>
		props.customCellSize &&
		props.customCellSize > 250 &&
		`
		padding: 24px;
		gap: 24px;
	`}
`
